// src/Footer.js
import React from "react";
import "./Footer.css";

const WHATSAPP_LINK = "https://wa.me/59898925827";
const WHATSAPP_DISPLAY = "098 925 827";

function Footer() {
  return (
    <footer className="footer">
      {/* WhatsApp a la IZQUIERDA */}
      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="footer-whatsapp"
        aria-label={`WhatsApp ${WHATSAPP_DISPLAY}`}
        title={`WhatsApp ${WHATSAPP_DISPLAY}`}
      >
        <svg className="wa-icon" viewBox="0 0 32 32" aria-hidden="true">
          <path d="M19.11 17.13c-.26-.13-1.52-.75-1.76-.83-.24-.08-.41-.13-.58.13-.17.26-.66.83-.81 1-.15.17-.3.2-.56.07-.26-.13-1.08-.4-2.06-1.28-.76-.68-1.28-1.52-1.43-1.78-.15-.26-.02-.4.11-.53.11-.11.26-.3.39-.45.13-.15.17-.26.26-.43.09-.17.04-.32-.02-.45-.06-.13-.58-1.39-.79-1.9-.21-.51-.42-.44-.58-.45-.15-.01-.32-.01-.49-.01-.17 0-.45.06-.68.32-.23.26-.9.88-.9 2.14 0 1.26.92 2.48 1.05 2.65.13.17 1.81 2.76 4.37 3.86.61.26 1.09.41 1.46.53.61.19 1.16.16 1.6.1.49-.07 1.52-.62 1.74-1.22.21-.6.21-1.11.15-1.22-.06-.11-.23-.17-.49-.3zM16 3C8.82 3 3 8.82 3 16c0 2.3.62 4.45 1.69 6.31L3 29l6.85-1.79C11.61 28.38 13.74 29 16 29c7.18 0 13-5.82 13-13S23.18 3 16 3zm0 23.8c-2.14 0-4.12-.64-5.77-1.74l-.41-.26-4.06 1.06 1.09-3.96-.27-.41A10.78 10.78 0 015.2 16c0-5.94 4.86-10.8 10.8-10.8S26.8 10.06 26.8 16 21.94 26.8 16 26.8z"/>
        </svg>
        <span className="wa-text">{WHATSAPP_DISPLAY}</span>
      </a>

      {/* separador (se oculta en mobile por CSS) */}
      <span className="footer-sep">·</span>

      {/* Texto a la DERECHA */}
      <span className="footer-line">
        Sistema de Reservas de Cuchilla Alta
      </span>
    </footer>
  );
}

export default Footer;
